// @hooks
import useSWR from "swr";

// @utils
import { chartApiUrl, fetcher } from "@/utils";

const endpoint = `${process.env.NEXT_PUBLIC_API_URL_V1}/shares`;

export function useShareRate(shouldFetch: boolean = true, variation?: string) {
  return useSWR(
    shouldFetch ? chartApiUrl(`${endpoint}/share-rate`, variation) : null,
    fetcher,
  );
}

export function useTShareUSDPrice(
  shouldFetch: boolean = true,
  variation?: string,
) {
  return useSWR(
    shouldFetch
      ? chartApiUrl(`${endpoint}/t-share-price-usd`, variation)
      : null,
    fetcher,
  );
}

export function useTShareValuations(
  shouldFetch: boolean = true,
  variation?: string,
) {
  return useSWR(
    shouldFetch
      ? chartApiUrl(`${endpoint}/t-share-valuations`, variation)
      : null,
    fetcher,
  );
}

export function useTShareDailyPayout(
  shouldFetch: boolean = true,
  variation?: string,
) {
  return useSWR(
    shouldFetch
      ? chartApiUrl(`${endpoint}/t-share-daily-payout`, variation)
      : null,
    fetcher,
  );
}

export function useTotalTShares(
  shouldFetch: boolean = true,
  variation?: string,
) {
  return useSWR(
    shouldFetch ? chartApiUrl(`${endpoint}/total-t-shares`, variation) : null,
    fetcher,
  );
}

export function useStakingParticipation(
  shouldFetch: boolean = true,
  variation?: string,
) {
  return useSWR(
    shouldFetch
      ? chartApiUrl(`${endpoint}/staking-participation-and-apy`, variation)
      : null,
    fetcher,
  );
}
